import {KoAPI} from "packages";
import { configs } from 'configuration';
const version = configs().API_VERSION;
export const FeedAPI = {
  getFeeds(query){
    return KoAPI.get(`/api/${version}/feed/all`, { query: { ...query } });
  },
  getMyFeeds(query){
    return KoAPI.get(`/api/${version}/feed/me`, { query: { ...query } });
  },
  getSavedFeeds(query){
    return KoAPI.get(`/api/${version}/feed/saved`, { query: { ...query } });
  },
  getShudledFeeds(query){
    return KoAPI.get(`/api/${version}/feed/queue`, { query: { ...query } });
  },
  postFeed(data, id){
    if(id){
      return KoAPI.update(`/api/${version}/feed/${id}`, { data });
    }else{
      return KoAPI.post(`/api/${version}/feed/create`, { data });
    }
  },
  getCounts(){
    return KoAPI.get(`/api/${version}/feed/counts`);
  },
  shareFeedLink(id){
    return KoAPI.update(`/api/${version}/feed/${id}/share`);
  },
  postLike(data, id){
    return KoAPI.update(`/api/${version}/feed/${id}/like`, { data });
  },
  postSave(data, id){
    return KoAPI.update(`/api/${version}/feed/${id}/save`, { data });
  },
  getFeedById(id){
    return KoAPI.get(`/api/${version}/feed/${id}`);
  },
  deleteFeed(id){
    return KoAPI.delete(`/api/${version}/feed/${id}`);
  },
  getPolls(query){
    return KoAPI.get(`/api/${version}/admin/poll/feed`, { query: { ...query } });
  },
  postPollVote(data){
    return KoAPI.post(`/api/${version}/admin/poll/vote/${data?.pollId}`, { data });
  },
  createCommentTicket(data, id, workspaceId) {
    if (id) {
      return KoAPI.update(`/api/${version}/ticket/comments/${data?.ticketId}/${id}`, {
        data: { ...data }, header: {
          "workspace": workspaceId
        }
      });
    } else {
      return KoAPI.post(`/api/${version}/ticket/comments`, {
        data: { ...data }, header: {
          "workspace": workspaceId
        }
      });
    }
  },
  getCommentsTicket(ticketId, workspaceId) {
    return KoAPI.get(`/api/${version}/ticket/comments/${ticketId}`, {
      header: {
        "workspace": workspaceId
      }
    });
  }
};